import createLucideIcon from '../createLucideIcon';

const ArrowBigRight = createLucideIcon('ArrowBigRight', [
  ['path', { d: 'M6 9h6V5l7 7-7 7v-4H6V9z', key: '7fvt9c' }],
]);

export default ArrowBigRight;
